import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import SeePitchesBy from 'components/Configs/SeePitchesBy';
import SectionHeader from 'components/Basic/SectionHeader/SectionHeader';
import { PlayerHandedness, PitchTagging } from 'types/CodegenReportTypes';
import usePracticePitcherSingleSessionReport from 'hooks/PracticeReport/PitcherSingle/usePracticePitcherSingleSessionReport';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  isConfigOpen: boolean;
  setConfigOpen: () => void;
};

const PracticePitcherSingleSessionConfig = ({ isConfigOpen, setConfigOpen }: Props) => {
  const { isCreate } = useReportId();

  const { specialConfigOptions, selectedConfgValues, setSelectedConfigValue, isLoadingReport } = usePracticePitcherSingleSessionReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader isOpen={isConfigOpen} onClick={setConfigOpen} title={t('Adjust report content')} isEnabled={isCreate} />
      {isConfigOpen && (
        <div className='report-layout-shelf-section'>
          <GenericRadioConfig
            label={t('Pitcher handedness:')}
            options={['Both', 'Left', 'Right'] satisfies PlayerHandedness[]}
            selected={selectedConfgValues.playerHandedness}
            setSelected={(newValue) => setSelectedConfigValue('playerHandedness', newValue)}
            disabled={isLoadingReport}
          />
          <SeePitchesBy
            seePitchesBy={selectedConfgValues.pitchGrouping}
            setSeePitchesBy={(newValue) => setSelectedConfigValue('pitchGrouping', newValue)}
            pitchTypes={selectedConfgValues.pitchTypes}
            setPitchTypes={(newValue) => setSelectedConfigValue('pitchTypes', newValue)}
            pitchTypeGroups={selectedConfgValues.pitchTypeGroups}
            setPitchTypeGroups={(newValue) => setSelectedConfigValue('pitchTypeGroups', newValue)}
            disabled={isLoadingReport}
            availablePitchTypes={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypes
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypes
            }
            availablePitchTypeGroups={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypeGroups
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypeGroups
            }
          />
        </div>
      )}
    </>
  );
};

export default PracticePitcherSingleSessionConfig;
